"use strict";

var Reflux = require("reflux");
var agendorAPI = require("app/util/api/agendor-api");

var MultiActionStore = require("app/util/flux/multi-action-store");

function createActions() {

  var actions = Reflux.createActions({
    "check": {},
    "search": {},
    "keyNavigate": {
      sync: true
    },
    "focusUser": {},
    "loadUsers": {
      children: ["completed", "failed"]
    },
    "populate": {
      sync: true
    }
  });

    actions.loadUsers.listen(function(selectedUsers) {
      agendorAPI.get("/users", {active: true, sort: "name"}, function(users, response) {
        try {
          this.completed(users, selectedUsers);
        } catch (error) {
          captureError(error);
        }
      }.bind(this));
    });

  return actions;
}

module.exports = MultiActionStore.factory(createActions);



// WEBPACK FOOTER //
// ./app/screens/Activity/actions/user-select-box-actions.js